var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { radiomarkStyle, radioIconStyle } from './styles';
function Radiomark(_a) {
    var inverted = _a.inverted, checked = _a.checked, error = _a.error, isFocusVisible = _a.isFocusVisible;
    return (_jsx("div", __assign({ css: radiomarkStyle({
            inverted: inverted,
            checked: checked,
            isFocusVisible: isFocusVisible,
            hasError: error,
        }) }, { children: checked && _jsx("span", { css: radioIconStyle({ inverted: inverted }) }) })));
}
export default Radiomark;
